import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Outlet } from "react-router-dom";

export default function UnconfirmedUsersMainGrid() {
  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid container spacing={2} columns={12} sx={{ mb: (theme) => theme.spacing(2) }}>
        <Grid size={{ sm: 12 }}>
          <Stack spacing={2} sx={{ alignItems: "center", mx: 3, pb: 10, mt: { xs: 8, md: 0 } }}>
            <Outlet />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
